// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsHospitalIndemnity = {
  benefits_section_hospital_indemnity: {
    contentful_name: '[DEFAULT] Benefits Section - Hospital Indemnity',
    admissions: '招生',
    confinement: '禁闭',
    icu: '重症监护室',
    pregnancy: '怀孕',
    hospital_admission: '入院',
    hospital_stay: '住院时间',
    icu_stay: 'ICU住院',
    hospital_admission_coverage: '每次入院{copay}({frequency}次/年)',
    hospital_stay_coverage: '{copay}每天({timeUnit}每{admissionOrYear})',
    icu_stay_coverage: '每天{copay}（每{admissionOrYear}最多{limit}{timeUnit}）',
    pregnancy_coverage_included: '包括妊娠相关住院的保障',
    pregnancy_coverage_not_included: '不包括妊娠相关住院的保障',
    once: '一次',
    up_to_x_times: '最多{times}{limit}',
    days: '天',
    weeks: '周',
    months: '个月',
    visits: '访问次数',
    admission: '入场',
    year: '年',
    hospital_stays: '住院治疗',
    hospital_admissions: '住院人数',
    covered_services: '承保服务',
    other_covered_services: '其他承保服务',
    additional_information: '附加信息',
    non_guaranteed_issue_disclaimer: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '**重要提示:**某些既往病症可能会影响您的保障范围。请务必在决定投保前查阅您的计划文件。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    spouse: '配偶',
    spouse_or_partner: '配偶或伴侣',
    spouse_or_kids: '配偶或子女',
    kids: '儿童',
    family: '家庭',
    lower_payout: '您的{affected}的付款可能低于您的付款。',
    display_name: '住院津贴',
    lower_payout_spouse_or_partner: '您的配偶或伴侣的赔付金额可能低于您的赔付金额。',
    lower_payout_spouse: '您配偶的赔付金额可能低于您的赔付金额。',
    lower_payout_spouse_or_children: '您的配偶或子女的赔付金额可能低于您的赔付金额。',
    lower_payout_family: '您家人的赔付金额可能低于您的赔付金额。',
    lower_payout_children: '您子女的赔付金额可能低于您的赔付金额。',
  },
};
